<template>
  <div v-if="page" class="page-container">
    <h2>{{ page.title }}</h2>
    <div v-html="page.content"></div>
  </div>
  <div v-else class="loading">
    <p>Loading...</p>
  </div>
</template>

<script>
import axios from 'axios';
import { useHead } from '@unhead/vue';

export default {
  name: 'Page',
  data() {
    return {
      page: null,
    };
  },
  watch: {
    // Watch for changes in page data to update meta tags
    page: {
      handler(newPage) {
        if (newPage) {
          this.updateMetaTags();
        }
      },
      immediate: true
    },
    // Re-fetch when slug changes
    '$route.params.slug': 'fetchPage',
  },
  async created() {
    await this.fetchPage();
  },
  methods: {
    async fetchPage() {
      const slug = this.$route.params.slug;
      try {
        const response = await axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/pages/by-slug/${slug}/`);
        this.page = response.data;
      } catch (err) {
        console.error("Failed to fetch page", err);
        this.page = { title: "Page Not Found", content: "<p>Halaman tidak ditemukan.</p>" };
      }
    },
    stripHtml(html) {
      // Create a temporary div element
      const tempDiv = document.createElement('div');
      // Set the HTML content of the div
      tempDiv.innerHTML = html;
      // Return the text content of the div
      return tempDiv.textContent || tempDiv.innerText || '';
    },
    updateMetaTags() {
      if (!this.page) return;
      
      // Extract content for description (first 10 words)
      const contentText = this.stripHtml(this.page.content);
      const firstTenWords = contentText.split(' ').slice(0, 10).join(' ') + '...';
      
      // Use @unhead/vue to set meta tags
      useHead({
        title: this.page.title + ' | HobiBaca',
        meta: [
          { name: 'description', content: firstTenWords },
          { name: 'keywords', content: `${this.page.title}, HobiBaca, buku, membaca` }
        ]
      });
    }
  }
};
</script>

<style scoped>
.page-container {
  max-width: 800px;
  margin: 40px auto;
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}

.loading {
  text-align: center;
  margin-top: 50px;
}

.subscription-card {
  border-radius: 15px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  margin-bottom: 20px;
  overflow: hidden;
  height: 100%;
  border: none;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}
</style>